__turbopack_context__.v({
  "SinglePost": "SinglePost-module-sass-module__Q2qm8G__SinglePost",
});
